import type {AddComponentTypeOptions} from 'grapesjs';
import {FORM_TEXT_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_FORM_TEXT_TYPE = 'postermywall-form-text';
const FORM_TEXT_DATA_ATTR = 'data-is-pmw-form-text';

export const POSTERMYWALL_FORM_TEXT: AddComponentTypeOptions = {
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    return el.getAttribute(FORM_TEXT_DATA_ATTR) !== null ? {type: POSTERMYWALL_FORM_TEXT_TYPE} : undefined;
  },
  extend: 'text',
  model: {
    defaults: {
      tagName: 'p',
      name: window.i18next.t('pmwjs_form_maker_name_label'),
      icon: 'icon-text',
      highlightable: true,
      hoverable: true,
      selectable: true,
      badgable: true,
      copyable: false,
      removable: false,
      draggable: false,
      editable: false,
      toolbar: [],
      content: window.i18next.t('pmwjs_insert_text'),
      attributes: {
        'data-pmw-type': POSTERMYWALL_FORM_TEXT_TYPE,
        [FORM_TEXT_DATA_ATTR]: '1',
      },
      style: FORM_TEXT_STYLES,
    },
  },
};
